import { useCallback } from 'react';
import { validateFields } from '../../../stream/transfer/control';
import useControlNext from '../../state/useControlNext';
/**
 * Returns function for field validations
 *
 * @documented
 * @category Form
 * @import import useValidateFields from '@gef-ui/form-core/hooks/form/useValidateFields'
 * @param {String} [formName] - when used, formStream$ is taken from stream storage instead of context
 * @returns {Function} validateFields
 * @example
 *
 * 	const validateFields = useValidateFields();
 *
 * 	validateFields([['firstName'],['pizzaName', 1]]); // takes list of fields with indexes
 *  validateFields([['firstName'],['pizzaName', 1]], { // you can also specify groups
 *				dirtyGroup: ['ERROR', 'REQUIRED', 'WARNING'],
 *				pristineGroup: ['ERROR'],
 *				notPresentGroup: [],
 *			},
 *		});
 *
 */ const useValidateFields = (formName)=>{
    const next = useControlNext(formName);
    const validateFieldsCb = useCallback((fieldsToValidate, groups)=>{
        next(validateFields({
            fieldsToValidate,
            groups
        }));
    }, [
        next
    ]);
    return validateFieldsCb;
};
export default useValidateFields;
